<template>
  <div>
    <div class="forget center">
      <div class="form-wrrapper mb-3">
        <h3>Forgot Password</h3>
        <p class="para">You can reset your password here</p>
        <validation-observer ref="observer">
          <form @submit.prevent="submit">
            <validation-provider
              vid="confirm"
              rules="required"
              v-slot="{ errors }"
            >
              <div class="show-passowrd mb-3">
                <Input
                  class="mb-base custom-input"
                  label="New Password"
                  :error="errors[0]"
                  :type="!show ? 'password' : 'text'"
                  v-model="password"
                />
                <span
                  :class="[
                    show ? 'mdi mdi-eye' : 'mdi mdi-eye-off',
                    'mdi-24px cursor'
                  ]"
                  @click="show = !show"
                ></span>
              </div>
            </validation-provider>
            <validation-provider
              rules="required|confirmed:confirm"
              v-slot="{ errors }"
            >
              <div class="show-passowrd mb-3">
                <Input
                  class="mb-base custom-input"
                  label="Confirm Password"
                  :error="errors[0]"
                  :type="!showPassword ? 'password' : 'text'"
                  v-model="confirmPassword"
                />
                <span
                  :class="[
                    showPassword ? 'mdi mdi-eye' : 'mdi mdi-eye-off',
                    'mdi-24px cursor'
                  ]"
                  @click="showPassword = !showPassword"
                ></span>
              </div>
            </validation-provider>
            <div class="actions">
              <Button
                className="button--primary w-100 custom-button"
                title="Reset Password"
                :onClick="resetPassword"
              ></Button>
            </div>
          </form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Input from "@/components/Input";
import Button from "@/components/Button";
export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    Button,
    Input
  },
  data() {
    return {
      show: false,
      showPassword: false,
      password: "",
      confirmPassword: ""
    };
  },
  methods: {
    resetPassword() {
      this.$refs.observer.validate().then(success => {
        if (!success && !this.robot) {
          return;
        }
        const payload = {
          password: this.password,
          confirm_password: this.confirmPassword,
          code: this.$route.query.code
        };
        this.$store.dispatch("auth/changePassword", payload).then(() => {
          this.$toasted.success("Password changed successfully").goAway("3000");
          this.$router.push("/");
        });
      });
    }
  }
};
</script>

<style>
.center {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.forget {
  background: var(--surface);
  box-shadow: var(--shadow-md);
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  width: 520px;
  padding: 40px 48px;
}
.forget h3 {
  margin-bottom: 8px;
  text-align: center;
  font-size: var(--fs-h1);
  font-weight: 600;
  color: var(--ink-900);
  letter-spacing: var(--tracking-tight);
}
.forget .para {
  text-align: center;
  margin-bottom: 28px;
  font-size: var(--fs-body);
  color: var(--muted);
  line-height: 1.5;
}
.form-wrrapper {
  padding-left: 0;
  padding-right: 0;
}
.custom-input input {
  background: var(--surface);
  border-radius: var(--radius-md);
  border: 1px solid var(--line);
  width: 100%;
  height: 44px;
  font-size: var(--fs-body);
  color: var(--text);
  transition: border-color var(--dur) var(--ease),
    box-shadow var(--dur) var(--ease);
}
.custom-input input::placeholder {
  color: var(--muted-soft);
}
.custom-input input:focus {
  outline: none;
  border-color: var(--accent-600);
  box-shadow: var(--ring);
}
.forget .custom-button {
  padding: 0;
  height: 44px;
}
.show-passowrd {
  position: relative;
}
.show-passowrd span {
  position: absolute;
  top: 47px;
  right: 20px;
  color: var(--muted-soft);
}
</style>
